import { FC, useRef } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { toggleInArray } from "../../../core/helpers";
import cn from "classnames";
import './SelectGrid.styles.scss';

interface iItem {
    title: string;
    value: string;
}

interface iProps {
    data: iItem[];
    value: string[];
    setValue: (value: string[]) => void;
}

const SelectGrid: FC<iProps> = (
    {
        data,
        setValue,
        value,
    }
) => {
    const nodeRef = useRef<HTMLDivElement>(null);
    // Set of visible chips, not selection — selecting a chip must not retrigger the crossfade.
    const resultsKey = data.map(item => item.value).join('|');

    const handleItemToggle = (itemValue: string) => () => {
        setValue(toggleInArray(value, itemValue));
    };

    return (
        <SwitchTransition mode="out-in">
            <CSSTransition
                key={resultsKey}
                nodeRef={nodeRef}
                timeout={200}
                classNames="SelectGrid-transition"
            >
                <div className="SelectGrid" ref={nodeRef}>
                    {data.map(item => (
                        <button
                            key={item.value}
                            type="button"
                            className={cn('SelectGrid__item', 'SelectGridItem', value.includes(item.value) && 'SelectGridItem--active')}
                            aria-pressed={value.includes(item.value)}
                            onClick={handleItemToggle(item.value)}
                        >
                            {/* Flex items are blockified — span keeps the highlighted <b> inline so spacing isn't collapsed. */}
                            <span dangerouslySetInnerHTML={{ __html: item.title }} />
                        </button>
                    ))}
                </div>
            </CSSTransition>
        </SwitchTransition>
    );
};

export default SelectGrid;
